import React, { Fragment } from "react";
import { withFormik, Formik, Form } from "formik";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import {
  FormStyle,
  FormGroupStyle,
  LabelFormHeader,
  FormRow,
  RowImage,
  ImageLogin,
} from "./FormStyle";
import {
  ButtonDefault,
  TextField,
  ButtonSecondary
} from "../shared/CustomInputs";
import { minLength } from "../../helpers/validations";
import LogoDefault from "../../assets/images/logo/logo.png";

const AuthFormNewPassword = withFormik({
  mapPropsToValues: () => ({
    newPassword: "",
    confirmPassword: ""
  })
});

const NewPassword = props => (
  <React.Fragment>
    <RowImage>
      <ImageLogin alt="..." src={LogoDefault} />
    </RowImage>
    <FormStyle>
      <Formik
        onSubmit={values =>
          values.newPassword === values.confirmPassword && props.submit(values)
        }
      >
        <Form>
          <FormGroupStyle>
            <Fragment>
              <LabelFormHeader>
                <FormattedMessage id="login.newPassword.rePassword" />
              </LabelFormHeader>
              <TextField
                validate={minLength}
                label={<FormattedMessage id="login.newPassword.rePassword" />}
                type="password"
                name="password"
              />
              <TextField
                validate={minLength}
                label={
                  <FormattedMessage id="login.newPassword.confirmPassword" />
                }
                type="password"
                name="confirmPassword"
              />
            </Fragment>
          </FormGroupStyle>
          <FormRow itens>
            <ButtonSecondary name={<FormattedMessage id="login.back" />} />
            <ButtonDefault
              name={<FormattedMessage id="sharedItems.confirme" />}
            />
          </FormRow>
        </Form>
      </Formik>
    </FormStyle>
  </React.Fragment>
);
NewPassword.propTypes = {
  submit: PropTypes.func
};

NewPassword.defaultProps = {
  submit: () => {}
};

export default AuthFormNewPassword(NewPassword);
